<mmscan-popup-menu [model]="items()" [icon]="primeIcons.COG" [text]="true" />
